/**
 * The bench in the build with no backend, for the review strip (/feed?bench=1): three bundled
 * pages standing in as cards waiting for a look, in bench_feed()'s row shape (the fit verdict and
 * the maker's word as the jsonb it returns, the maker's handle), and the log of what
 * card_set_status was asked. Reachable only when the e2e suite marks the visitor an admin
 * (window.__blitzFixture, honoured only in this build): without a backend nobody is an admin.
 * Plain rows, kept apart from src/api/cards.ts so neither imports the other's values.
 */
import type { CardRow, CardStatus } from './cards';

export interface MockBenchRow extends CardRow {
  status: CardStatus;
  fit: { summary?: string } | null;
  fit_ok: boolean | null;
  generation: { made_with?: string } | null;
  handle: string | null;
}

const bundled = (card_id: string, title: string, verbs: string[]): CardRow => ({
  card_id,
  class: 'web',
  source: 'hosted',
  title,
  developer: 'Blitz Labs',
  description: '',
  page_url: `/cards/${card_id}/index.html`,
  wasm_url: null,
  data_url: null,
  thumbnail_url: `/cards/${card_id}/thumb.svg`,
  accent: null,
  verbs,
  created_at: '2026-09-26T09:00:00Z',
});

export const MOCK_BENCH: MockBenchRow[] = [
  { ...bundled('orbit-cut', 'Orbit Cut', ['timing']), status: 'bench', fit: { summary: 'fits' }, fit_ok: true, generation: { made_with: 'Claude' }, handle: 'mira' },
  { ...bundled('colour-split', 'Colour Split', ['preference']), status: 'bench', fit: { summary: 'wider than a phone' }, fit_ok: false, generation: null, handle: 'jun' },
  { ...bundled('sand-fall', 'Sand Fall', ['toy']), status: 'bench', fit: null, fit_ok: null, generation: null, handle: null },
];

/** What card_set_status was asked in this build, in order: the e2e suite reads it from window.__blitz. */
export const MOCK_STATUS_LOG: Array<{ card_id: string; status: CardStatus; reason: string }> = [];
